export default function (state) {
    state.Name = '';
    state.FirstName = '';
    state.MiddleName = '';
    state.NameLat = '';
    state.FirstNameLat = '';
    state.MiddleNameLat = '';
    state.Code = '';
    state.CitizenId = '';
    state.Constant = false;
    state.Birthday = '';
    state.Gender = 0;
    state.AgeCategory = 0;
    state.Comment = '';
    state.PassportRusSer = '';
    state.PassportRusNumber = '';
    state.PassportRusDate = '';
    state.PassportRusByWhom = '';
    state.PassportType = '';
    state.PassportNumber = '';
    state.PassportDate = '';
    state.PassportDateEnd = '';
    state.PassportByWhom = '';
    state.PostIndex = '';
    state.PostArea = '';
    state.PostCity = '';
    state.PostStreet = '';
    state.PostCountry = '';
    state.PostDistrict = '';
    state.PostBuilding = '';
    state.PostFlat = '';
    state.Phone = '';
    state.Mobile_CC = '';
    state.Mobile_RG = '';
    state.Mobile_Number = '';
    state.Fax = '';
    state.Email = '';
    state.IsSendSMS = false;
    state.IsSendEmail = false;
    state.BirthCountry = '';
    state.BirthCity = '';
    state.BirthArea = '';
    state.BirthDistrict = '';
    state.Family = '';
}